import { makeAutoObservable } from 'mobx';
import React from 'react';
import { Divider, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import { GridDataEntry } from 'controls/grid/gridDataEntry';
import { GridViewSelectorProps } from 'controls/grid/viewManager/gridViewSelectorProps';

const i18n = require('core/localization').translator({
	'Add View': { no: 'Legg visning' },
});

const b = require('b_').with('grid-view-manager');

export class ViewManagerStore<T extends GridDataEntry> {
	showDetails: boolean;
	nameEditing: boolean;
	originalName: string;
	currentTab: string = 'filters';

	props: GridViewSelectorProps<T>;

	constructor() {
		makeAutoObservable(this);
	}

	get gridStore() {
		return this.props?.store;
	}

	get options() {
		if (!this.gridStore) return [];

		return this.gridStore.state.views.map((x) => ({
			label: x.nameEffective,
			value: x.id,
		}));
	}

	get isFavorite() {
		if (!this.gridStore) return false;

		return this.gridStore.state.initialViewId == this.gridStore.state.currentViewId;
	}

	get popupRender() {
		return (menu: React.ReactElement) => {
			return (
				<>
					{menu}

					{this.props.createViewDisabled !== true && (
						<>
							<Divider className={b('divider')} />

							<Typography.Link className={b('add-button')} onClick={this.addView}>
								<PlusOutlined /> {i18n('Add View')}
							</Typography.Link>
						</>
					)}
				</>
			);
		};
	}

	addView = () => {
		this.gridStore.state.duplicateCurrentView();
		this.showDetails = true;
		this.currentTab = 'enabled-columns';
	};

	deleteView = () => {
		this.gridStore.state.deleteView();
		this.showDetails = false;
	};

	setFavorite = () => {
		this.gridStore.state.initialViewId = this.gridStore.state.currentViewId;
	};

	editName = () => {
		this.originalName = this.gridStore.state.currentView.name;
		this.nameEditing = true;
	};

	cancelEditing = () => {
		this.gridStore.state.currentView.name = this.originalName;
		this.confirmNameChange();
	};

	confirmNameChange = () => {
		if (!this.gridStore.state.currentView.name.trim()) {
			this.gridStore.state.currentView.name = this.originalName;
		}

		this.originalName = null;
		this.nameEditing = false;
	};

	toggleDetails = () => {
		this.showDetails = !this.showDetails;
	};

	closeDetails = () => {
		this.showDetails = false;
	};
}
